import { useSelector } from 'src/hooks/useSelector';

export const useResumeSearchCount = () => {
    const isSimilarSearch = useSelector((state) => state.resumeSearchResult.isSimilarSearch);
    const { totalUngroupedResults, normalSearchResults, normalGroupedSearchResults } = useSelector(
        (state) => state.resumeSearchResult.stats
    );

    if (isSimilarSearch) {
        return totalUngroupedResults;
    }

    return normalGroupedSearchResults ? normalSearchResults : totalUngroupedResults;
};
